import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, emailVerfication, sendPhoneVerificationCode } from 'src/app/shared/constants';
import { catchError, map } from 'rxjs/operators';
import { UikitService } from './uikit.service';
import { environment } from 'src/environment';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class EditAccountService {
  mobileVerification = new BehaviorSubject(false);
  constructor(private http: HttpClient, private uikitService: UikitService, private storageService: StorageService) { }

  editAccountFun(data: any): Observable<any> {
    const headers = new HttpHeaders({'Content-type': undefined});
    const editUrl = environment.apiEndpoint + environment.version + User;
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    data['profile_id'] = profileId ?  profileId : uId;
    return this.http.post<any>(editUrl, data, { headers }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }), catchError((error) => {
        if (error.error && error.error.code !== 1002) {
          this.uikitService.notifyError(error);
          this.mobileVerification.next(false);
        }
        throw error;
      })
    );
  }
  sendPhoneVerficationRequest(postData): Observable<any> {
        const profileId = this.storageService.getSessionStore('profileId');
        const uId = this.storageService.getLocalStore('u_id');
        postData['profile_id'] = profileId || uId;
        const phoneVerficationUrl = environment.apiEndpoint + environment.version + sendPhoneVerificationCode;
        return this.http.post(phoneVerficationUrl, postData ).pipe(
            map((response: any) => {
              if (response.status_code === 200) {
                return response;
              }
              else {
                this.uikitService.notifyError(response);
                this.mobileVerification.next(false);
              }
            }), catchError((error) => {
              if (error.error && error.error.code !== 1002) {
                this.uikitService.notifyError(error);
              }
              return error;
            })
        );
  }

  sendEmailVerificationRequest(requestData) {
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    requestData['profile_id'] = profileId || uId;
    const emailVerficationUrl = environment.apiEndpoint + environment.version + emailVerfication;
    return this.http.post(emailVerficationUrl, requestData ).pipe(
        map((response: any) => {
          if (response.status_code === 200) {
            return response.data;
          }
          else {
            this.uikitService.notifyError(response);
          }
        }), catchError((error) => {
          if (error.error && error.error.code !== 1002) {
            this.uikitService.notifyError(error);
          }
          return error;
        })
    );
  }
}
